export default __webpack_public_path__ + "static/media/data_setting_7.a1285dac.png";